import { supabase } from '@/integrations/supabase/client'

export type AuditLogType =
  | 'SETTINGS_UPDATE'
  | 'ORDER_DELETE'
  | 'COLLABORATOR_UPDATE'
  | 'CASH_TRANSACTION'
  | 'CASH_REGISTER_OPEN'
  | 'CASH_REGISTER_CLOSE'
  | 'OTHER'

interface AuditParams {
  companyId: string
  type: AuditLogType
  details: string
  role?: string
  status?: string
}

/**
 * Registra uma ação na tabela de auditoria (audit_logs).
 * Retorna true em caso de sucesso ou false se houver erro.
 */
export async function logAuditAction({
  companyId,
  type,
  details,
  role = 'Administrador',
  status = 'SUCCESS',
}: AuditParams): Promise<boolean> {
  if (!companyId) return false

  try {
    const { error } = await supabase.from('audit_logs').insert({
      id: crypto.randomUUID(),
      company_id: companyId,
      type,
      role,
      status,
      details,
      timestamp: new Date().toISOString(),
      ip: 'Dashboard V2',
    })

    if (error) {
      console.error('Erro ao registrar log de auditoria:', error)
      return false
    }
    return true
  } catch (err) {
    console.error('Exceção ao registrar log:', err)
    return false
  }
}
